import { Duration, parse } from "iso8601-duration";

import logError from "utils/logError";

import { resApiClient } from "../services/reservations-api";

export const getPickupReadinessTime = async ({
  dispensaryId,
}: {
  dispensaryId: number;
}): Promise<Duration | null> => {
  try {
    const { data } = await resApiClient.getDispensaryPickupReadiness(
      dispensaryId
    );

    return data && data !== "" ? parse(data) : null;
  } catch (e) {
    logError(e.message || "Unknown error", {
      functionName: "getPickupReadinessTime",
      service: "reservations",
    });

    return null;
  }
};
